export const TEST_MODE_HINT = "Тестовый режим, до 10 ответов";
